import React from 'react';

export default class Page10 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToGainBuyInAndCommitment');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                                <section>
                                    <div className="">
                                        <div className="ilead-rgt people">
                                            <div className="innerpadding">
                                                <div className="ilead-contentarea">

                                                    <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                        <span className="heading">Further Information</span>
                                                    </div>
                                                    <div className="paraspace"><p>If you found this tool useful, then
                                                        you are likely to find the following tools both insightful and
                                                        relevant:</p></div>
                                                    <div className="keyquestionpad">
                                                        <ul className="greenbullet-list sept">
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToBeAssertive')}>How
                                                                to be assertive</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToInfluenceOthers')}>How
                                                                to influence others</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToDevelopRapport')}>How
                                                                to develop rapport</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToCommunicateEffectively')}>How
                                                                to communicate effectively</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToActivelyListen')}>How
                                                                to actively listen</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToManageYourImpact')}>How
                                                                to manage your impact</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToBuildAndMaintainTrust')}>How
                                                                to build and maintain trust</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToMakeReasonedJudgements')}>How
                                                                to make reasoned judgements</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToWinAndManageResources')}>How
                                                                to win and manage resources.</div></li>


                                                        </ul>
                                                    </div>
                                                    <div className="circle_title "><img
                                                        src={require('@images/browndot.jpg')}
                                                        alt=""/>REFERENCES</div>

                                                    <ol className="testclass">
                                                        <li><p className="further_info_content">Maslow, A.H.
                                                            (1971).<span className="subtiltereg">  The farther reaches of human nature.</span> New
                                                            York: Penguin Compass</p></li>
                                                        <li><p className="further_info_content">Huss, E., &amp; Magos,
                                                            M. (2012). Relationship between self-actualisation and
                                                            employment for at-risk young unemployed women.<span
                                                                className="subtiltereg">  Journal of Education and Work,</span> (ahead-of-print),
                                                            1-17.</p></li>
                                                        <li><p className="further_info_content">Berson, Y., Shamir, B.,
                                                            Avolio, B. J., &amp; Popper, M. (2001). The relationship
                                                            between vision strength, leadership style, and context.<span
                                                                className="subtiltereg"> The Leadership Quarterly,</span> 12(1),
                                                            53-73.</p></li>


                                                    </ol>


                                                    <div className="left-btn"><div
                                                         onClick={this.props.handleChangePage('Page9')}
                                                        className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                                    <div className="right-btn"><div
                                                         onClick={this._savePageStatus('People')}
                                                        className="button-next-previous-done">Done</div></div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}